// @flow
import { Record } from "immutable"

import isUndefined from "common/utils/isUndefined"

export type InfantsInputConditions = {
  trolley?: boolean,
  stroller?: boolean,
  hand_weight?: number,
}

export const InfantsConditions = Record({
  trolley: undefined,
  differentHandWeight: false,
  handWeight: undefined,
})

const mapperInfantsConditions = (conditions: ?InfantsInputConditions): InfantsConditions => {
  let infantsConditions = new InfantsConditions()

  if (!conditions) return infantsConditions

  // Trolley
  if (!isUndefined(conditions.trolley)) {
    infantsConditions = infantsConditions.set("trolley", conditions.trolley)
  }

  // Stroller - BookingApi now incorrectly returns "stroller" instead of "trolley", TODO: remove after api fix
  if (!isUndefined(conditions.stroller)) {
    infantsConditions = infantsConditions.set("trolley", conditions.stroller)
  }

  // Custom hand weight
  if (!isUndefined(conditions.hand_weight)) {
    infantsConditions = infantsConditions.set("handWeight", conditions.hand_weight)
    infantsConditions = infantsConditions.set("differentHandWeight", true) // use custom hand weight for infants
  }

  return infantsConditions
}

export default mapperInfantsConditions
